if (!customElements.get("td-announcement-bar")) {
  class TdAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      requestAnimationFrame(() => {
        this.initCloseFunctionality();
      });
    }

    initCloseFunctionality() {
      this.closeIcon = this.querySelector('.td-announcement-bar__close-icon');
      this.section = this.querySelector('.td-announcement-bar');

      if (this.closeIcon && this.section) {
        this.closeIcon.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.hideAnnouncementBar();
        });
      }
    }

    hideAnnouncementBar() {
      if (this.section) {
        this.section.classList.add('td-announcement-bar--hidden');
      }
    }
  }

  customElements.define("td-announcement-bar", TdAnnouncementBar);
}
